module.exports = __webpack_public_path__ + "media/customizations/jubilee/logo-new-3cc8f4d48469cb822d56559f1cbe06cd.png";